import { ZfBox, ZfStack } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { TopicGrid, TopicTiles } from '../components/dashboard';
import { useContainerDimensions } from '../hooks/useContainerDimensions';

export const DashboardNoActiveSession: FunctionComponent = () => {
    const { t } = useTranslation();
    const containerDimensions = useContainerDimensions();

    return (
        <ZfStack direction="row" justify="center" style={{ flex: 1, backgroundColor: 'var(--bg-color-default-muted)' }}>
            <TopicGrid isPresentationMode={false} {...containerDimensions}>
                <ZfBox style={{ gridRow: '1', gridColumnEnd: 'span 4', alignSelf: 'center' }}>
                    <h4>{t('dashboardTitle')}</h4>
                </ZfBox>
                <TopicTiles {...containerDimensions} />
            </TopicGrid>
        </ZfStack>
    );
};
